export interface TestPlanDto {
  id: string;
  projectId: string;
  name: string;
  description?: string;
  version?: string;
  isActive: boolean;
  testCases?: TestCaseDto[];
  testRuns?: TestRunDto[];
}

export interface TestCaseDto {
  id: string;
  testPlanId: string;
  title: string;
  description?: string;
  preconditions?: string;
  steps?: string;
  expectedResult?: string;
  status: number;
  sortOrder: number;
}

export interface TestRunDto {
  id: string;
  testPlanId: string;
  name: string;
  status: number;
  executedById?: string;
  notes?: string;
  startedAt?: string;
  completedAt?: string;
  testResults?: TestResultDto[];
}

export interface TestResultDto {
  id: string;
  testRunId: string;
  testCaseId: string;
  status: number;
  executedById?: string;
  actualResult?: string;
  notes?: string;
  executedAt?: string;
}

export interface TestPlanSummaryDto {
  totalCases: number;
  passedRuns: number;
  failedRuns: number;
  blockedRuns: number;
  pendingRuns: number;
  passRatePercent?: number;
}

export const TEST_CASE_STATUS_OPTIONS = [
  { value: 0, label: 'Draft' },
  { value: 1, label: 'Ready' },
  { value: 2, label: 'Deprecated' }
];

export const TEST_RUN_STATUS_OPTIONS = [
  { value: 0, label: 'Pending' },
  { value: 1, label: 'In Progress' },
  { value: 2, label: 'Passed' },
  { value: 3, label: 'Failed' },
  { value: 4, label: 'Blocked' },
  { value: 5, label: 'Skipped' }
];

export const TEST_RESULT_STATUS_OPTIONS = [
  { value: 2, label: 'Pass' },
  { value: 3, label: 'Fail' },
  { value: 4, label: 'Blocked' },
  { value: 5, label: 'Skipped' }
];
